export interface Orders {
  project_id: string,
  project_name: string,
  order_id: number,
  job_id: number,
  job_pk: number,
  reqid: number,
  order_date: string,
  employee_phm: number,
  order_cid: number,
  employee_order: number,
  order_delivery: string,
  cond_delivery: number,
  cond_payment: number,
  purchasing_id: string,
  purchasing_price: number,
  selling_price: number,
  order_status: string,
  order_subject: string,
  company_name: string,
  order_salutation: string,
  order_firstname: string,
  order_lastname: string,
  order_street: string,
  order_postcode: string,
  order_city: string,
  order_country: string,
  order_confirmation_id: string,
  company_delivery: number,
  person_delivery: number,
  comments?: string,
  comment_phm?: string,
  specification?: string,
}

export interface OrdersList {
  active?: boolean,
  budget: number,
  comments?: string,
  comment_phm?: string,
  company_name: string,
  controlling_nr: string,
  delivery_date: string,
  description: string,
  heat_nr: string,
  jobid: number,
  material: string,
  name: string,
  number_of_pieces: number,
  ordercid: number,
  orderid: number,
  part?: number,
  position: number,
  /** Originalnotation aus dem Altsystem (z. B. "6.1"); leer bei PPS-Zeilen. */
  position_label?: string,
  project_number: string,
  project_name: string,
  remarks: string,
  serial_nr: string,
  side_agreements: string,
  specification?: string,
  status: string,
  taric: string,
  technical_drawing: string,
  technology: boolean,
}

export class SingleOrder {
  project_id: string = '';
  project_name: string = '';
  order_id: number = 0;
  job_id: number = 0;
  job_pk: number = 0;
  reqid: number = 0;
  order_date: string = '';
  employee_phm: number = 0;
  order_cid: number = 0;
  employee_order: number = 0;
  order_delivery: string = '';
  cond_delivery: number = 0;
  cond_payment: number = 0;
  purchasing_id: string = '';
  purchasing_price: number = 0;
  selling_price: number = 0;
  order_status: string = '';
  order_subject: string = '';
  company_name: string = '';
  order_salutation: string = '';
  order_firstname: string = '';
  order_lastname: string = '';
  order_street: string = '';
  order_postcode: string = '';
  order_city: string = '';
  order_country: string = '';
  order_confirmation_id: string = '';
  company_delivery: number = 0;
  person_delivery: number = 0;
  comments?: string = '';
  comment_phm?: string = '';
  specification?: string = '';
}

class StepI {
  project_id: string = '';
  order_cid: number = 0;
  company_name: string = '';
  order_street: string = '';
  order_postcode: string = '';
  order_city: string = '';
  order_country: string = '';
  order_subject: string = '';
  order_date: string = '';
  order_delivery: string = '';
  order_status: string = '';
  order_confirmation_id: string = '';
  purchasing_price: string = '';
  selling_price: string = ''
}

class StepII {
  employee_phm: string = '';
}

class StepIII {
  employee_order: string = '';
}

class StepIV {
  cond_payment: number = 0;
  cond_delivery: number = 0;
}

class StepV {
  companydelivery: number = 0;
  persondelivery: number = 0;
}

export interface Order {
  stepI: StepI;
  stepII: StepII;
  stepIII: StepIII;
  stepIV: StepIV;
  stepV: StepV;
}
